import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'top_match_face_info';
export const useTopMatchFaceInfoTranslation = (): UseTranslationResponse<string, string> => (
  useTranslation('entities', { keyPrefix })
);

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    similarity: 'Лицо',
    user_data: 'Информация',
    external_id: 'Внешний ID',
    lists: 'Списки',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    similarity: 'Face',
    user_data: 'Information',
    external_id: 'External ID',
    lists: 'Lists',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    similarity: 'Face',
    user_data: 'Informação',
    external_id: 'ID externo',
    lists: 'Listas',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    similarity: 'Rostro',
    user_data: 'Información',
    external_id: 'ID externo',
    lists: 'Listas',
  },
}) : {}) as Record<string, unknown>;
